import { parseApiInstant } from "../datetime/parseApiInstant";

/** Single largest unit: "1 day left", "7 hours left", etc. */
export function formatDueCountdown(dueAtIso: string | null | undefined, nowMs = Date.now()): string | null {
  if (!dueAtIso) return null;
  const dueDate = parseApiInstant(dueAtIso);
  if (!dueDate) return null;
  const due = dueDate.getTime();

  const ms = due - nowMs;
  if (ms <= 0) return "Past due";

  const totalSec = Math.floor(ms / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  if (days >= 1) return `${days} day${days === 1 ? "" : "s"} left`;
  if (hours >= 1) return `${hours} hour${hours === 1 ? "" : "s"} left`;
  if (minutes >= 1) return `${minutes} minute${minutes === 1 ? "" : "s"} left`;
  const sec = Math.max(seconds, 1);
  return `${sec} second${sec === 1 ? "" : "s"} left`;
}

export function formatDueDateShort(dueAtIso: string | null | undefined): string | null {
  const d = parseApiInstant(dueAtIso);
  if (!d) return null;
  try {
    return d.toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return null;
  }
}
